// packages/world-model/src/traits/purchasable/index.ts

export * from './purchasableTrait.js';
